// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .warning-row {\n  background: rgb(255, 205, 205);\n}\n.el-table .success-row {\n  background: #f0f9eb;\n}\n.container {\n  margin: 0 50px 0 50px;\n}\nh1 {\n  margin: 50px 0 50px 0;\n}\nh2 {\n  text-align: left;\n  margin-bottom: 20px;\n  /* margin-left: 20px; */\n}\n.el-icon-loading {\n  font-size: 30px;\n}\n\n", ""]);
// Exports
module.exports = exports;
